<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Da li ste sigurni da želite da obrišete post?</p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="deletePost"
        :disabled="loading"
      >
        <span v-if="!loading">Potvrdi</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['post']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('table', ['initTable', 'getPostsByCommunity']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    deletePost() {
      if (this.loading) {
        return;
      }

      this.loadingStarted();

      let memberId;
      if (this.$router.history.current.name === 'communityPosts') {
        memberId = this.$store.getters.getActiveCommunity.member_id;
      } else {
        memberId = this.$store.getters.getCommunities.filter(
          c => c.community_id === this.post.communityId
        )[0].member_id;
      }

      let deleteRequest = {
        member_id: memberId,
        post_id: this.post.postId
      };

      this.loadingStarted();
      axios
        .post('/post/delete', deleteRequest)
        .then(() => {
          if (this.$router.history.current.name === 'communityPosts') {
            // this.initTable('pollTable');
            this.getPostsByCommunity(
              this.$store.getters.getActiveCommunity.community_id
            );
          }
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped></style>
